export default {"src":"/_next/static/media/logoText_194x24.ed659cc9.svg","height":24,"width":194,"blurWidth":0,"blurHeight":0};